module.exports = __webpack_public_path__ + "static/media/huomiot.708a774b.md";